import { FadeIn } from "../ui/fade-in"
import { Marquee } from "../ui/marquee"

// Importez directement les images
import axians from "../../assets/logos/partners/axians.png"
import aebdm from "../../assets/logos/partners/aebdm.png"
import dxc from "../../assets/logos/partners/dxc.png"
import omnidata from "../../assets/logos/partners/omnidata.png"

export function PartnersSection() {
  const partners = [
    {
      name: "Axians",
      logo: axians,
      description: "Partenaire Gold en solutions de sécurité Microsoft",
    },
    {
      name: "AEBDM",
      logo: aebdm,
      description: "Partenaire certifié pour les solutions de sécurité réseau",
    },
    {
      name: "DXC",
      logo: dxc,
      description: "Partenaire avancé pour la sécurité cloud",
    },
    {
      name: "OMNIDATA",
      logo: omnidata,
      description: "Partenaire stratégique pour les solutions d'intelligence artificielle",
    },
  ]

  const duplicatedPartners = [...partners , ...partners , ...partners]

  return (
      <section id="partners" className="py-24 bg-gradient-to-b from-black to-zinc-950 relative overflow-hidden">
        {/* Background accent */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-red-600/50 to-transparent"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn direction="up">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Nos <span className="text-red-600">Partenaires</span>
              </h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Nous collaborons avec les leaders mondiaux de la technologie pour offrir des solutions de sécurité de
                pointe à nos clients.
              </p>
            </div>
          </FadeIn>

          <div className="relative">
            {/* Fade out effect on edges */}
            <div className="absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-black to-transparent pointer-events-none"></div>
            <div className="absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-black to-transparent pointer-events-none"></div>

            <Marquee speed={100} pauseOnHover={true}>
              {duplicatedPartners.map((partner, index) => (
                  <div
                      key={index}
                      className="mx-8 flex flex-col items-center group min-w-[180px] transition-transform duration-300 ease-in-out hover:-translate-y-1"
                  >
                    {/* Logo container with fixed dimensions */}
                    <div className="w-40 h-16 flex items-center justify-center">
                      <img
                          src={partner.logo || "/placeholder.svg"}
                          alt={partner.name}
                          className="h-20 object-contain filter grayscale transition-all duration-300 group-hover:grayscale-0"
                      />
                    </div>
                  </div>
              ))}
            </Marquee>
          </div>
        </div>
      </section>
  )
}
